import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTasksByErpProductId = (
    token: string,
    backend: string,
    erpproductid: number,
) => {
    return fetch(
        `${getApiUrl(backend)}tasks/by_erpproductid/${erpproductid}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getTasksByErpProductId;